export default {
  version: 'v1.3.5 (0311)',
  env: 'PROD', // 'LOCAL', 'TB', 'PROD'
  socketIoUrl: {
    LOCAL: 'https://localhost:7103/SignalServer',
    TB: 'https://dev.knowledgetalk.co.kr:7100/SignalServer',
    PROD: 'https://knowledgetalk.co.kr:7103/SignalServer'
  },
  developerMode: false,
  privateMode: {
    switch: false,
    cpName: 'KnowledgePoint',
    cpCode: {
      LOCAL: 'KP-20200101-01',
      TB: 'KP-20200101-01',
      PROD: 'KP-20200101-01'
    },
    authKey: {
      LOCAL: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjcENvZGUiOiJURVNULUpVU1RJTiIsImNwTmFtZSI6IlRlc3RDUF9KdXN0aW4iLCJhbGxvd01heFVzZXIiOjAsImFsbG93U3RhcnREYXRlIjoiMjAyMC0xMC0yMCIsImFsbG93RW5kRGF0ZSI6IjIwMjAtMTAtMjEiLCJpYXQiOjE2MDMxNzQ0NjJ9.1g5WwGACqN_6RXc1qScN7997xMrHOsqzueN8fkB4NoU', // knowledgepointtoken
      TB: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjcENvZGUiOiJURVNULUpVU1RJTiIsImNwTmFtZSI6IlRlc3RDUF9KdXN0aW4iLCJhbGxvd01heFVzZXIiOjAsImFsbG93U3RhcnREYXRlIjoiMjAyMC0xMC0yMCIsImFsbG93RW5kRGF0ZSI6IjIwMjAtMTAtMjEiLCJpYXQiOjE2MDMxNzQ0NjJ9.1g5WwGACqN_6RXc1qScN7997xMrHOsqzueN8fkB4NoU', // knowledgepointtoken
      PROD: '' // eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoi64Kg66as7KeA7Y-s7J247Yq4IiwibWF4VXNlciI6IjUwMDAwMDAwIiwic3RhcnREYXRlIjoiMjAyMC0wMS0wMVQwNjo0NzowMC4wMDBaIiwiZW5kRGF0ZSI6IjIwMzAtMTItMzFUMDY6NDc6MDAuMDAwWiIsImF1dGhDb2RlIjoiS1AtMjAyMDAxMDEtMDEiLCJjb21wYW55Q29kZSI6IkxJQy0wMSIsImlhdCI6MTU4NzUzODExNH0.73A0UiiMHJeIS8pIgoN4DfEWT4QCsMnXkO4uUdnfbYI
    }
  },
  iceServer: {
    LOCAL: {
      p2p: {
        iceServers: [{ urls: 'turn:dev.knowledgetalk.co.kr:46000', username: 'kpoint', credential: 'kpoint01' }, { urls : 'stun:dev.knowledgetalk.co.kr:46000' }]
      },
      media: {
        iceServers: [{ urls : 'stun:dev.knowledgetalk.co.kr:46000' }]
      }
    },
    TB: {
      p2p: {
        iceServers: [{ urls: 'turn:dev.knowledgetalk.co.kr:46000', username: 'kpoint', credential: 'kpoint01' }, { urls : 'stun:dev.knowledgetalk.co.kr:46000' }]
      },
      media: {
        iceServers: [{ urls : 'stun:dev.knowledgetalk.co.kr:46000' }]
      }
    },
    PROD: {
      p2p: {
        iceServers: [{ urls : 'stun:prod.stun.knowledgetalk.co.kr:46000' }, { urls: 'turn:prod.turn.knowledgetalk.co.kr:46000', username: 'kpoint', credential: 'kpoint01' }]
      },
      media: {
        iceServers: [{ urls : 'stun:prod.stun.knowledgetalk.co.kr:46000' }]
      }
    },
  }, // RELEASED
  constraints: {
    share: { width: 224, height: 126, frameRate: 10 }, // video constraint when screen sharing
    p2p: { width: 960, height: 540, frameRate: 15 }, // 1 by 1
    four: { width: 640, height: 360, frameRate: 12 }, // 2 by 2
    six: { width: 480, height: 270, frameRate: 12 }, // 3 by 2
    nine: { width: 320, height: 180, frameRate: 12 }, // 3 by 3
    twelve: { width: 320, height: 180, frameRate: 10 }, // 4 by 3
    sixteen: { width: 224, height: 126, frameRate: 10 }, // 4 by 4
    // 210202 mz, 16자 해상도 변경
  },
  constraintsLow: {
    share: { width: 192, height: 108, frameRate: 10 }, // video constraint when screen sharing
    p2p: { width: 640, height: 360, frameRate: 15 }, // 1 by 1
    four: { width: 480, height: 270, frameRate: 12 }, // 2 by 2
    six: { width: 320, height: 180, frameRate: 12 }, // 3 by 2
    nine: { width: 224, height: 126, frameRate: 12 }, // 3 by 3
    twelve: { width: 224, height: 126, frameRate: 10 }, // 4 by 3
    sixteen: { width: 192, height: 108, frameRate: 10 }, // 4 by 4
  },
  getConstraint: function (isHighResolution) {
    if(isHighResolution === false)
      return this.constraintsLow;
    return this.constraints;
  },
  pingInterval: 50,
  lengthOfRoomId: 8,
  listOfDomains: ['localhost', 'ktgenie.com', 'cococall.net'],
  networkCheckInterval: 5000,
  networkCheckByNum: (num, video = true) => {
    if(!video){
      return 4;
    } else if (num <= 2) {
      return 220;
    } else if (num <= 4) {
      return 170;
    } else if (num <= 6) {
      return 110;
    } else if (num <= 9) {
      return 64;
    } else if (num <= 12) {
      return 54;
    } else if (num <= 16) {
      return 32;
    } else if (num <= 20) {
      return 26;
    } else if (num <= 25) {
      return 23;
    }
  },
  badNetworkLevel: 0.8,
  goodNetworkLevel: 1.05
}



// WEBPACK FOOTER //
// ./src/config.js